module.exports = __webpack_public_path__ + "assets/icon-cryptohead.e0074330.svg";